var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-platinumMild font-light w-full h-28 mb-6 flex justify-center items-center text-sm text-cosmosFire rounded-lg"},[_c('h2',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }